import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';

/**
 * page header component
 * @class PageHeaderComponent
 * @typedef {PageHeaderComponent}
 */
@Component( {
    selector: 'app-page-header',
    standalone: true,
    imports: [NgIf],
    templateUrl: './page-header.component.html',
    styleUrl: './page-header.component.scss'
} )
export class PageHeaderComponent {
    /** page headline */
    @Input( { required: true } ) headline: string | undefined;
    /** page subline */
    @Input() subline: string | undefined;
    /** flag, if button are used in view */
    @Input() hasButton = false;
}
